import { pciProxy } from '../../../../../../../services/pciProxy';
import { changePaymentCardType } from '../../../../../slices';
import { connectCheckoutField } from '../../../../../utils/connectCheckoutField';
import { invokePciProxy } from '../../utils/invokePciProxy';

const { updateCardNumberMetadata } = pciProxy.actions;

export const inject = connectCheckoutField({
    mapAdditionalDispatchProps: (dispatch: $TSFixMe) => ({
        onMetadataChange: (metadata: $TSFixMe) => {
            dispatch(updateCardNumberMetadata(metadata));

            const { type } = metadata;
            dispatch(changePaymentCardType(type));
        },

        registerChange: invokePciProxy('registerCardChange', dispatch),
        registerFocus: invokePciProxy('registerCardFocus', dispatch),
        registerBlur: invokePciProxy('registerCardBlur', dispatch),
        setStyle: invokePciProxy('setCardStyle', dispatch),
    }),
});
